import { Component, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PaymentService } from '../_services/payment-service.service';

@Component({
  selector: 'app-coupon-code',
  templateUrl: './coupon-code.component.html',
  styleUrls: ['./coupon-code.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CouponCodeComponent),
      multi: true
    }
  ]
})
export class CouponCodeComponent implements OnInit, ControlValueAccessor {

  private changeHandler: any;

  public isDisabled: boolean;
  public couponValid: boolean = null;
  couponCodeUpdate = new Subject<string>();

  private _couponCode: string;
  public get couponCode(): string {
    return this._couponCode;
  }
  public set couponCode(value: string) {
    this._couponCode = value;

    if (this.changeHandler) {
      this.changeHandler(this.couponCode);
    }
  }

  private refreshCouponValid() {
    this.couponValid = null;
    this.couponCode = this.couponCode.trim();
    if (this.couponCode && this.couponCode.length > 0) {
      this.isDisabled = true;
      this.paymentService.checkCoupon(this.couponCode)
      .subscribe(c => {
        this.couponValid = c;
        this.isDisabled = false;
      });
    }
  }

  writeValue(obj: any): void {
    this.couponCode = obj;
  }
  registerOnChange(fn: any): void {
    this.changeHandler = fn;
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  constructor(private paymentService: PaymentService) {}

  ngOnInit() {
    this.couponCodeUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.refreshCouponValid();
      });

  }
}
